import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { icons } from '@cobliteam/base-components/src/styles/icons';

const icon = (color?: string) => css`
  svg {
    color: ${color || colors.primary.default};
    height: ${icons.size.small};
    width: ${icons.size.small};
  }
`;

export default { icon };
